(() => {
  // create flex container with row-gap set
  const flex = document.createElement('div');
  Object.assign(flex.style, {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    rowGap: '1px',
    visibility: 'hidden',
  });

  // create two, elements inside it
  flex.appendChild(document.createElement('div'));
  flex.appendChild(document.createElement('div'));

  window.swinger.observer.initialize('body', (body) => {
    body.appendChild(flex);

    const isSupported = flex.scrollHeight === 1; // flex container should be 1px high from the row-gap

    flex.parentNode.removeChild(flex);

    if (isSupported) {
      return;
    }

    document.documentElement.classList.add('no-flex-gap-support');
  }, false);
})();
